import { BROADCAST } from '../constants/platformIds';
import { metricOptions } from '../constants/pacingMetrics';
const SOCIAL_PLACEMENT_TYPE = '1';
const BROADCAST_PLACEMENT_TYPE = '2';

export const getPlatformTypeOptions = (ids: string[]) => {
    const hasBroadcast = ids.includes(`${BROADCAST}`);
    return [
        { value: 1, label: 'Social' },
        ...(hasBroadcast ? [{ value: 2, label: 'Broadcast' }] : []),
    ];
};

export const getMetricOptions = (
    placementTypes,
    hasClientPermission: boolean,
) => {
    if (!placementTypes.length) return [];

    const options = metricOptions.filter(o =>
        placementTypes.every(pt => o.platformTypes.includes(pt)),
    );

    // Only show impressions for broadcasts if the permission is on
    if (
        hasClientPermission ||
        !placementTypes.includes(BROADCAST_PLACEMENT_TYPE)
    ) {
        return options;
    } else {
        const filteredOptions = options.filter(
            item => item.name !== 'Impressions',
        );
        return filteredOptions;
    }
};

export const getMetricTooltip = (metricId: number, platformTypes: string[]) => {
    switch (metricId) {
        case 1:
            if (
                platformTypes.includes(SOCIAL_PLACEMENT_TYPE) &&
                platformTypes.includes(BROADCAST_PLACEMENT_TYPE)
            ) {
                return 'Total combined impressions';
            } else if (platformTypes.includes(SOCIAL_PLACEMENT_TYPE)) {
                return 'Combined impressions for social images and videos';
            } else if (platformTypes.includes(BROADCAST_PLACEMENT_TYPE)) {
                return 'Total impressions on broadcast';
            }
            break;
        case 2:
            return 'Total duration, in seconds, across all broadcast networks';

        case 3:
            return 'Total number of exposures';

        case 4:
            return 'Total generated value';

        default:
            return;
    }
};
